module.exports = require("live/components/ui/global-alert");